// 创建一个ajax通用函数
import $ from 'n-zepto';
import { message, Modal } from 'antd';
import querystring from 'querystring';
import hashHistory from '../history';

message.config({
    top: 100,
    duration: 3,
});

let isModalShownOnce = false;
localStorage.setItem('IS_NEED_OPEN_MODAL', 'need');

const reloadPage = () => {
    const clearTimeInter = setInterval(() => {
        const isNeedReload = localStorage.getItem('NEED_RELOAD_PAGE_INFOS');

        if (isNeedReload === 'need') {
            isModalShownOnce = false;
            localStorage.setItem('NEED_RELOAD_PAGE_INFOS', '');
            localStorage.setItem('IS_NEED_OPEN_MODAL', 'need');
            window.location.reload();
            clearInterval(clearTimeInter);
        }
    }, 1000);
};

reloadPage();

const checkVersion = (version) => {
    if (window.STATIC_PACKAGE_VERSION && Number(version) > Number(window.STATIC_PACKAGE_VERSION)) {
        const isNeedOpenModal = localStorage.getItem('IS_NEED_OPEN_MODAL');
        if (!isModalShownOnce && isNeedOpenModal === 'need') {
            isModalShownOnce = true;
            localStorage.setItem('IS_NEED_OPEN_MODAL', '');
            Modal.confirm({
                title: '版本强制更新提示',
                content: '系统已经更新，为了不影响你的正常工作，请及时刷新！',
                okText: '立即刷新',
                cancelText: '延迟五分钟',
                onOk: () => {
                    localStorage.setItem('NEED_RELOAD_PAGE_INFOS', 'need');
                },
                onCancel: () => {
                    localStorage.setItem('NEED_RELOAD_PAGE_INFOS', '');
                    setTimeout(() => {
                        isModalShownOnce = false;
                        localStorage.setItem('IS_NEED_OPEN_MODAL', 'need');
                    }, 5 * 60 * 1000);
                },
            });
        }
    }
};

const ajaxUtils = (type = 'GET', url = '', params = {}, callback, failCallback) => {
    const ajaxParams = {
        type,
        url,
        data: JSON.stringify(params),
        contentType: 'application/json; charset=utf-8',
        dataType: 'JSON',
        cache: false,
        timeout: 30000,
        success: (res, textStatus, jqXHR) => {
            // console.log(jqXHR);
            const version = jqXHR.getResponseHeader('X-Support-Web-Version');
            checkVersion(version);
            const data = JSON.parse(res);
            if (data && data.meta) {
                if (data.meta.code === 30001) {
                    window.location.href = `/api/login?redirectUrl=${encodeURIComponent(window.location.href)}`;
                } else if (data.meta.code === 30006) {
                    window.location.href = '/login';
                } else if (data.meta.code === 40612) {
                    window.location.href = '/candidates';
                } else if (data.meta.code === 40008) {
                  // 后端返回 40008 表示无权限访问
                    hashHistory.push('noPermission');
                } else if (data.meta.code === 0) {
                    if (callback) {
                        callback(data);
                    }
                } else if (data.meta.code !== 0) {
                    if (failCallback) {
                        failCallback(data);
                    } else {
                        message.error(data.meta.message);
                    }
                }
            } else if (failCallback) {
                failCallback(data);
            } else {
                message.error('请求发生错误');
            }
        },
        error: (jqXHR, _errorType) => {
            if (failCallback) {
                const data = {
                    meta: {
                        message: '请求发生错误',
                    },
                };
                failCallback(data);
            } else if (jqXHR.status === 400 || jqXHR.status === 500 || jqXHR.status === 403) {
              const response = JSON.parse(jqXHR.response)
              message.error(response.meta.message)
            }else if (jqXHR.status === 401) {
              if(window.location.hostname === 'jobhuntertest.intra.xiaojukeji.com' ||
              window.location.hostname === 'hunter-stage.intra.xiaojukeji.com' ||
              location.hostname === 'hunter.didichuxing.com') {
                window.location.href = '/login';
              }else {
                window.location.href = `/api/login?redirectUrl=${encodeURIComponent(window.location.href)}`;
              }
            }else {
               message.error('请求发生错误');
            }
        }
    };

    if (type === 'GET') {
        ajaxParams.data = querystring.stringify(params);
    }

    $.ajax(ajaxParams);
};

export function ajaxGet(url, params, callback, failCallback) {
    ajaxUtils('GET', url, params, callback, failCallback);
}

export function ajaxPost(url, params, callback, failCallback) {
    ajaxUtils('POST', url, params, callback, failCallback);
}

export function ajaxPut(url, params, callback, failCallback) {
    ajaxUtils('PUT', url, params, callback, failCallback);
}

export function ajaxDelete(url, params, callback, failCallback) {
    ajaxUtils('DELETE', url, params, callback, failCallback);
}
